import type {
    PrhHolidayHomeOnsaDTO,
    PrhHouseOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';
import { COVERABLE_CODE } from '../../../../../constants/coverable';

const ROOF_TYPE_BUILT_UP = 'Built up, fladt tag';

const shouldRenderDoorsAge = (houseCoverable: PrhHouseOnsaDTO | PrhHolidayHomeOnsaDTO): boolean => {
    if (houseCoverable.constructionYear === undefined) return false;
    const ageOfHouse = new Date().getFullYear() - houseCoverable.constructionYear;
    return houseCoverable.flavourCode === COVERABLE_CODE.prhHouse && ageOfHouse >= 30;
};

const shouldRenderRoofAge20 = (
    houseCoverable: PrhHouseOnsaDTO | PrhHolidayHomeOnsaDTO
): boolean => {
    if (houseCoverable.constructionYear === undefined) return false;
    const ageOfHouse = new Date().getFullYear() - houseCoverable.constructionYear;
    return (
        houseCoverable.flavourCode === COVERABLE_CODE.prhHouse &&
        houseCoverable.roofType === ROOF_TYPE_BUILT_UP &&
        ageOfHouse >= 20
    );
};

const shouldRenderRoofAge30 = (
    houseCoverable: PrhHouseOnsaDTO | PrhHolidayHomeOnsaDTO
): boolean => {
    if (houseCoverable.constructionYear === undefined) return false;
    const ageOfHouse = new Date().getFullYear() - houseCoverable.constructionYear;
    return (
        houseCoverable.flavourCode === COVERABLE_CODE.prhHouse &&
        houseCoverable.roofType !== ROOF_TYPE_BUILT_UP &&
        ageOfHouse >= 30
    );
};

const shouldRenderUWIQuestionsStep = (
    houseCoverable: PrhHouseOnsaDTO | PrhHolidayHomeOnsaDTO | undefined
): boolean => {
    if (houseCoverable === undefined) return false;
    return (
        houseCoverable.flavourCode === COVERABLE_CODE.prhHouse ||
        houseCoverable.buyingHouse === 'Ja' ||
        shouldRenderDoorsAge(houseCoverable) ||
        shouldRenderRoofAge20(houseCoverable) ||
        shouldRenderRoofAge30(houseCoverable)
    );
};

const areHouseUWIQuestionsValid = (
    houseCoverable: PrhHouseOnsaDTO | PrhHolidayHomeOnsaDTO
): boolean => {
    if (
        houseCoverable.flavourCode === COVERABLE_CODE.prhHouse &&
        !(houseCoverable as PrhHouseOnsaDTO).rental
    ) {
        return false;
    }

    if (
        shouldRenderDoorsAge(houseCoverable) &&
        !houseCoverable.allDoorsAndWindowsOver30AndMadeOfWood
    ) {
        return false;
    }

    if (shouldRenderRoofAge20(houseCoverable) && !houseCoverable.roofOver20) {
        return false;
    }

    if (shouldRenderRoofAge30(houseCoverable) && !houseCoverable.roofOver30) {
        return false;
    }

    if (
        houseCoverable.buyingHouse === 'Ja' &&
        (houseCoverable.previousOwnerDeceased === undefined ||
            houseCoverable.foreclosureAuction === undefined)
    ) {
        return false;
    }

    return true;
};

export {
    shouldRenderDoorsAge,
    shouldRenderRoofAge20,
    shouldRenderRoofAge30,
    shouldRenderUWIQuestionsStep,
    areHouseUWIQuestionsValid
};
